/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {seguradorasRoute} from "./seguradoras/shared/data.service";
import {AuthGuardService} from "../shared/services/auth-guard.service";
import {segurosRoute} from "./seguros/shared/data.service";
import {SegurosComponent} from "./seguros/seguros.component";
import {segurosRoutes} from "./seguros/seguros-routing.module";
import {obrigacoesRoute} from "./obrigacoes/shared/data.service";
import {ObrigacoesComponent} from "./obrigacoes/obrigacoes.component";
import {obrigacoesRoutes} from "./obrigacoes/obrigacoes-routing.module";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class DespachosRoutingModule {}

export const despachosRoutes: any[] = [
    {
        path: '',
        redirectTo: '/' + seguradorasRoute,
        pathMatch: 'full'
    },{
        path: segurosRoute,
        component: SegurosComponent,
        canActivate: [AuthGuardService],
        children: segurosRoutes
    }, {
        path: obrigacoesRoute,
        component: ObrigacoesComponent,
        canActivate: [AuthGuardService],
        children: obrigacoesRoutes,
    }
];


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/despachos-routing.module.ts
 **/